import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Path, RuleGroupTypeIC} from 'react-querybuilder';
import {RelationalGroup} from '../../components/pages/index-search/RelationshipGroupPopup';
import {getUpdatedSavedSearchRelationalGroupByIdFromQuery} from '../../components/pages/index-search/query-field/query-field-utils';

interface EditField {
  id: string;
  operator: string;
  value: string;
  path: Path;
  saved_search_path?: string;
  hasTransferList?: boolean;
  savedSearchRelationalGroup?: RelationalGroup[];
}

interface QueryState {
  builder: RuleGroupTypeIC;
  index: any;
  editField?: EditField;
  savedSearchById: Record<string, string>;
  hasTransferListById: Record<string, boolean>;
  savedSearchRelationalGroupById: Record<string, RelationalGroup[]>;
}

const initialState: QueryState = {
  builder: {rules: []},
  index: {},
  savedSearchById: {},
  hasTransferListById: {},
  savedSearchRelationalGroupById: {},
};

const querySlice = createSlice({
  name: 'query',
  initialState,
  reducers: {
    updateQuery(state, action: PayloadAction<RuleGroupTypeIC>) {
      state.savedSearchRelationalGroupById =
        getUpdatedSavedSearchRelationalGroupByIdFromQuery(
          action.payload,
          state.savedSearchRelationalGroupById
        );
      state.builder = action.payload;
    },
    resetQuery(state) {
      state.builder = initialState.builder;
      state.savedSearchRelationalGroupById =
        initialState.savedSearchRelationalGroupById;
    },
    setIndex(state, action: PayloadAction<any>) {
      state.index = action.payload;
    },
    setEditField(state, action: PayloadAction<EditField | undefined>) {
      if (action.payload?.id) {
        const id = action.payload.id.split('__').at(-1);
        const saved_search_path =
          state.savedSearchById?.[id ?? ''] ?? undefined;
        const hasTransferList = state.hasTransferListById?.[id ?? ''] ?? false;
        const savedSearchRelationalGroup =
          state.savedSearchRelationalGroupById?.[id ?? ''] ?? [];
        state.editField = {
          ...action.payload,
          saved_search_path,
          hasTransferList,
          savedSearchRelationalGroup,
        };
      } else {
        state.editField = action.payload;
      }
    },
    setSavedSearchById(
      state,
      action: PayloadAction<{
        id: string;
        value: string;
      }>
    ) {
      state.savedSearchById[action.payload.id] = action.payload.value;
    },
    setHasTransferListById(
      state,
      action: PayloadAction<{
        id: string;
        value: boolean;
      }>
    ) {
      state.hasTransferListById[action.payload.id] = action.payload.value;
    },
    setSavedSearchRelationalGroupById(
      state,
      action: PayloadAction<{
        id: string;
        value: RelationalGroup[];
      }>
    ) {
      state.savedSearchRelationalGroupById[action.payload.id] =
        action.payload.value;
    },
  },
});

export const {
  updateQuery,
  resetQuery,
  setIndex,
  setEditField,
  setSavedSearchById,
  setHasTransferListById,
  setSavedSearchRelationalGroupById,
} = querySlice.actions;
export default querySlice.reducer;
